export default __webpack_public_path__ + "static/media/vue-weather.8a706044.png";